// 定义模态框 ID 常量
export const COUPON_RETENTION_MODAL_ID = 'modal-coupon-retention'
export const INVITE_COUPONS_MODAL_ID = 'modal-invite-coupons'
export const MEMBER_UPGRADE_SUCCESS_MODAL_ID = 'modal-member-upgrade-success'
export const MEMBER_UPGRADE_PLAN_MODAL_ID = 'modal-member-upgrade-plan'
export const CREATE_CANVAS_MODAL_ID = 'modal-create-canvas'
export const CANVAS_SELECT_MODAL_ID = 'modal-canvas-select'
export const PREMIUM_FEATURE_MODAL_ID = 'modal-premium-feature'
export const LOCALISATION_MODAL_ID = 'modal-localisation'